import { render, staticRenderFns } from "./RegisterCard.vue?vue&type=template&id=b1a15908&scoped=true"
import script from "./RegisterCard.vue?vue&type=script&lang=js"
export * from "./RegisterCard.vue?vue&type=script&lang=js"
import style0 from "./RegisterCard.vue?vue&type=style&index=0&id=b1a15908&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a15908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1a15908')) {
      api.createRecord('b1a15908', component.options)
    } else {
      api.reload('b1a15908', component.options)
    }
    module.hot.accept("./RegisterCard.vue?vue&type=template&id=b1a15908&scoped=true", function () {
      api.rerender('b1a15908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/components/RegisterCard.vue"
export default component.exports